import { createVNode as _createVNode, renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-edd001ec")

_pushScopeId("data-v-edd001ec")
const _hoisted_1 = /*#__PURE__*/_createVNode("i", { class: "el-icon-setting" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_drawer = _resolveComponent("el-drawer")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", {
      class: "handle-button",
      style: {'top': _ctx.buttonTop+'px','backgroundColor': _ctx.theme},
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.show= true))
    }, [
      _hoisted_1
    ], 4),
    _createVNode(_component_el_drawer, {
      title: "设置",
      modelValue: _ctx.show,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.show = $event)),
      size: "300px",
      direction: _ctx.direction,
      "destroy-on-close": ""
    }, {
      default: _withId(() => [
        _renderSlot(_ctx.$slots, "default")
      ]),
      _: 3
    }, 8, ["modelValue", "direction"])
  ], 64))
})